import {
  Assignment,
  Call,
  Assessment,
  Archive,
  Comment,
  SupervisorAccount,
  Person,
  Unarchive,
  Work,
  Warning,
  AssignmentLate,
  Campaign,
  Grade,
  Sms
} from '@mui/icons-material';
import { O_TUT } from '@lba-dev/package.local-globals/aOptions';
import { A_ARC } from '@lba-dev/package.local-globals/aStatus';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import {
  FACT_PACK,
  FACT_BLOC,
} from '@lba-dev/package.local-globals/TypeFacturier';
import { Map, fromJS } from 'immutable';

import {
  cancelDebrief,
  askForDebrief,
  debrief,
  checkDebriefProcess,
} from '../../../actions/artisanManagement';
import {
  archive,
  tutelle,
  comment,
  appel,
  unarchive,
  facturierArtisan,
  historyPackArtisan,
  signalement,
  absences,
  sendInstructions,
  permanentArchive,
  callReminderDialog,
  sendSMS,
  envoyerMailAssuranceExpirée,
  sendTutoCbVideoSms
} from '../../../actions/artisan';
import { showSMS } from '../../../actions/inter';
import { sliceNumber } from '../../Calls/FomatText';
export default [
  {
    name: 'Modifier',
    icon: Assignment,
    link: ({ id }) => {
      window.open(`/artisan/${id}`);
    },
    action: (props, elem) => {
      props.navigate(`/artisan/${elem.id}`);
    },
    customVisible: (elem, props) => permit(props.user, { key: 'editArtisan' }),
  },
  {
    name: 'Appeler',
    icon: Call,
    sub: [1, 2, 3].map((e) => ({
      name: `Téléphone Artisan ${e}`,
      value: (props, elem) => elem?.[`tel${e}`]
        ? sliceNumber(elem[`tel${e}`])
        : null,
      action: (props, elem) => {
        appel(
          { artisan: new Map(elem), intervention: props.intervention },
          elem[`tel${e}`],
        ).then((appelId) => {
          if (typeof props.artisanAppel === 'function') {
            props.artisanAppel(appelId, elem._id);
          }
        });
      },
    })),
    customVisible: (elem, props) =>
      props.selected &&
      (!props.selected.checkNumber ||
        props.userIdSelected === props.selected._id),
  },
  {
    name: 'SMS',
    icon: Sms,
    sub: [1, 2, 3].map((e) => ({
      name: `Téléphone Artisan ${e}`,
      value: (props, elem) => elem?.[`tel${e}`]
        ? sliceNumber(elem[`tel${e}`])
        : null,
      action: (props, elem) => {
        showSMS(props, elem._id, 'artisan', elem[`tel${e}`]);
      },
    }))
  },
  {
    name: 'Commenter',
    icon: Comment,
    action: comment,
  },
  {
    name: 'Absences',
    icon: AssignmentLate,
    action: absences,
  },
  {
    name: 'Recap',
    icon: Assessment,
    link: ({ id }) => window.open(`/artisan/${id}/recap`),
    action: (props, elem) => {
      props.navigate(`/artisan/${elem.id}/recap`);
    },
  },
  {
    name: 'Mettre Tutelle',
    icon: SupervisorAccount,
    action: tutelle,
    customVisible: (elem, props) => {
      const user = props.users.find((u) => u._id === props.userId);

      return (
        user &&
        permit(user, { key: 'chefPart' }) &&
        props.selected &&
        props.selected.option &&
        !props.selected.option.includes(O_TUT)
      );
    },
  },
  {
    name: 'Sortir Tutelle',
    icon: Person,
    action: (...arg) => tutelle(...arg, true),
    customVisible: (elem, props) => {
      const user = props.users.find((u) => u._id === props.userId);

      return (
        user &&
        permit(user, { key: 'chefPart' }) &&
        props.selected &&
        props.selected.option &&
        props.selected.option.includes(O_TUT)
      );
    },
  },
  {
    name: 'Archiver',
    icon: Archive,
    action: archive,
    customVisible: (elem, props) => {
      const user = props.users.find((u) => u._id === props.userId);
      return (
        user &&
        permit(user, { key: 'archiveSST' }) &&
        props.selected &&
        props.selected.status !== A_ARC
      );
    },
  },
  {
    name: 'Communication',
    icon: Campaign,
    sub: [
      {
        name: 'Envoyer l\'adresse des chèques',
        action: sendInstructions,
        customVisible: (elem, props) =>
          props.selected && !props.selected.sentInstructions,
      },
      {
        name: 'Renvoyer l\'adresse des chèques',
        action: sendInstructions,
        customVisible: (elem, props) => {
          const user = props.users.find((u) => u._id === props.userId);

          return (
            user &&
            props.selected &&
            props.selected.sentInstructions &&
            permit(user, { key: 'resendInstructions' })
          );
        },
      },
      {
        name: 'Relance doc (mail)',
        action: callReminderDialog,
      },
      {
        name: 'Relance doc (message)',
        action: (p, elem) => sendSMS({ ...p, artisan: fromJS(elem) }),
      },
      {
        name: 'Tuto lien CB',
        action: sendTutoCbVideoSms,
      },
      {
        name: 'Mail assurance expirée',
        action: envoyerMailAssuranceExpirée,
      }
    ],
  },
  {
    name: 'Archiver définitivement',
    icon: Archive,
    action: permanentArchive,
    customVisible: (elem, props) => {
      const user = props.users.find((u) => u._id === props.userId);
      return (
        user &&
        permit(user, { key: 'archiveSST' }) &&
        props.selected &&
        props.selected.status === A_ARC &&
        !props.selected.date.permanentArchive
      );
    },
  },
  {
    name: 'Dé-Archiver',
    icon: Unarchive,
    action: unarchive,
    customVisible: (elem, props) =>
      props.selected && props.selected.status === A_ARC,
  },
  {
    name: 'Pack Artisan',
    icon: Work,
    sub: [
      {
        name: 'Demander un pack',
        action: (...arg) => facturierArtisan(...arg, FACT_PACK),
      },
      {
        name: 'Demander un facturier',
        action: (...arg) => facturierArtisan(...arg, FACT_BLOC),
      },
      {
        name: 'Historique d\'envois',
        action: historyPackArtisan,
      },
    ],
  },
  {
    name: 'Debrief',
    icon: Grade,
    customVisible: (elem, props) =>
      permit(props.user, { key: 'debriefAjout' }) &&
      props.selected &&
      props.selected.status !== A_ARC &&
      checkDebriefProcess(props.selected.debriefProcess),
    sub: [
      {
        name: 'Debrief OK',
        action: (props, elem) => debrief(elem),
        customVisible: (elem, props) => props.selected.toDebrief,
      },
      {
        name: 'Annuler le debrief',
        action: cancelDebrief,
        customVisible: (elem, props) => props.selected.toDebrief,
      },
      {
        name: 'Demander un debrief',
        action: askForDebrief,
        customVisible: (elem, props) =>
          !props.selected.toDebrief &&
          checkDebriefProcess(props.selected.debriefProcess),
      }
    ]
  },
  {
    name: 'Signaler',
    icon: Warning,
    action: signalement,
  }
];
